export default "__VITE_ASSET__BtO0nlrc__"